import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

// import Img1 from "../../assets/images/order1.png";
// import Img2 from "../../assets/images/order2.png";
// import OverviewImg6 from "../../assets/images/who-we-serve/overviewimg6.png";

// import { motion } from "framer-motion";
import "./index.css";
// import OverviewImg1 from "../../assets/images/who-we-serve/overviewimg1.png";
// import OverviewImg2 from "../../assets/images/who-we-serve/overviewimg2.png";
// import OverviewImg3 from "../../assets/images/who-we-serve/overviewimg3.png";
// import OverviewImg4 from "../../assets/images/who-we-serve/overviewimg4.png";
// import OverviewImg5 from "../../assets/images/who-we-serve/overviewimg5.png";
// import OverviewImg6 from "../../assets/images/who-we-serve/overviewimg6.png";
// import OverviewImg7 from "../../assets/images/who-we-serve/overviewimg7.png";
// import OverviewImg8 from "../../assets/images/who-we-serve/overviewimg8.png";
import { t } from "i18next";
// import {isMobile} from "react-device-detect";
import { useNavigate } from "react-router-dom";

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 3,
  },
  largeDesktop: {
    breakpoint: { max: 3000, min: 2050 },
    items: 3,
  },
  desktop: {
    breakpoint: { max: 2050, min: 1240 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1240, min: 768 },
    items: 3,
  },
  mobile1: {
    breakpoint: { max: 768, min: 414 },
    items: 1,
  },
  mobile2: {
    breakpoint: { max: 600, min: 0 },
    items: 1,
  },
};

const data = [
  {
    icon: (
      <svg
        width="47"
        height="46"
        viewBox="0 0 47 46"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_6_7793)">
          <path
            d="M24.4745 45.3789H3.78631C2.94244 45.378 2.13337 45.0425 1.53666 44.4457C0.939958 43.8491 0.604358 43.04 0.603516 42.1961V4.00262C0.604358 3.15875 0.939958 2.34968 1.53666 1.75297C2.13337 1.15627 2.94244 0.820667 3.78631 0.819824H24.4745V4.00262H3.78631V42.1961H24.4745V35.8305H27.6572V42.1961C27.6564 43.04 27.3208 43.8491 26.7241 44.4457C26.1274 45.0425 25.3184 45.378 24.4745 45.3789Z"
            fill="#333333"
          />
          <path
            d="M32.2101 9.8836V11.1196L33.4387 11.2538C40.0492 11.9764 45.1727 17.4847 45.1727 24.1123V25.9167H18.7637V24.1123C18.7637 17.4847 23.8871 11.9764 30.4976 11.2538L31.7263 11.1196V9.8836V7.98535H32.2101V9.8836Z"
            stroke="#240B3B"
            strokeWidth="2.75688"
          />
          <path
            d="M19.7728 39.0137C21.0912 39.0137 22.1599 37.9449 22.1599 36.6266C22.1599 35.3083 21.0912 34.2395 19.7728 34.2395C18.4545 34.2395 17.3857 35.3083 17.3857 36.6266C17.3857 37.9449 18.4545 39.0137 19.7728 39.0137Z"
            fill="black"
          />
        </g>
      </svg>
    ),
    title: "Smooth, Intuitive Experience",
    content:
      "User-friendly platform that effortlessly simplifies management. VenueBoost's inherent ease means no wasted time repeatedly training staff.",
  },
  {
    icon: (
      <svg
        width="47"
        height="47"
        viewBox="0 0 47 47"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_6_7784)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.5703 21.1621C11.8964 21.1621 13.1681 20.6353 14.1058 19.6976C15.0435 18.76 15.5703 17.4882 15.5703 16.1621C15.5703 14.836 15.0435 13.5642 14.1058 12.6266C13.1681 11.6889 11.8964 11.1621 10.5703 11.1621C9.24423 11.1621 7.97246 11.6889 7.03477 12.6266C6.09709 13.5642 5.57031 14.836 5.57031 16.1621C5.57031 17.4882 6.09709 18.76 7.03477 19.6976C7.97246 20.6353 9.24423 21.1621 10.5703 21.1621ZM10.5703 23.6621C11.5552 23.6621 12.5305 23.4681 13.4404 23.0912C14.3503 22.7143 15.1771 22.1618 15.8736 21.4654C16.57 20.769 17.1225 19.9422 17.4994 19.0322C17.8763 18.1223 18.0703 17.147 18.0703 16.1621C18.0703 15.1772 17.8763 14.2019 17.4994 13.292C17.1225 12.382 16.57 11.5552 15.8736 10.8588C15.1771 10.1624 14.3503 9.60992 13.4404 9.23301C12.5305 8.8561 11.5552 8.66211 10.5703 8.66211C8.58118 8.66211 6.67353 9.45229 5.26701 10.8588C3.86048 12.2653 3.07031 14.173 3.07031 16.1621C3.07031 18.1512 3.86048 20.0589 5.26701 21.4654C6.67353 22.8719 8.58118 23.6621 10.5703 23.6621Z"
            fill="#333333"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.70531 20.9019C7.82172 21.018 7.91407 21.1559 7.97709 21.3078C8.04011 21.4597 8.07254 21.6225 8.07254 21.7869C8.07254 21.9513 8.04011 22.1141 7.97709 22.266C7.91407 22.4178 7.82172 22.5558 7.70531 22.6719L6.86031 23.5144C5.23415 25.141 4.32052 27.3468 4.32031 29.6469V34.2869C4.32031 34.6184 4.18861 34.9364 3.95419 35.1708C3.71977 35.4052 3.40183 35.5369 3.07031 35.5369C2.73879 35.5369 2.42084 35.4052 2.18642 35.1708C1.952 34.9364 1.82031 34.6184 1.82031 34.2869V29.6469C1.82066 26.6838 2.99777 23.8422 5.09281 21.7469L5.93531 20.9019C6.05142 20.7855 6.18936 20.6931 6.34122 20.6301C6.49309 20.5671 6.65589 20.5347 6.82031 20.5347C6.98473 20.5347 7.14753 20.5671 7.29939 20.6301C7.45126 20.6931 7.58919 20.7855 7.70531 20.9019ZM37.1853 20.1519C37.0689 20.268 36.9765 20.4059 36.9135 20.5578C36.8505 20.7097 36.818 20.8725 36.818 21.0369C36.818 21.2013 36.8505 21.3641 36.9135 21.516C36.9765 21.6678 37.0689 21.8058 37.1853 21.9219L38.0303 22.7644C38.8356 23.5697 39.4744 24.5258 39.9102 25.578C40.346 26.6302 40.5703 27.758 40.5703 28.8969V34.2869C40.5703 34.6184 40.702 34.9364 40.9364 35.1708C41.1708 35.4052 41.4888 35.5369 41.8203 35.5369C42.1518 35.5369 42.4697 35.4052 42.7042 35.1708C42.9386 34.9364 43.0703 34.6184 43.0703 34.2869V28.8969C43.0699 25.9338 41.8928 23.0922 39.7978 20.9969L38.9553 20.1519C38.8392 20.0355 38.7012 19.9431 38.5494 19.8801C38.3975 19.8171 38.2347 19.7847 38.0703 19.7847C37.9059 19.7847 37.7431 19.8171 37.5912 19.8801C37.4393 19.9431 37.3014 20.0355 37.1853 20.1519Z"
            fill="#333333"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M33.0703 21.1621C31.7442 21.1621 30.4724 20.6353 29.5347 19.6976C28.5971 18.76 28.0703 17.4882 28.0703 16.1621C28.0703 14.836 28.5971 13.5642 29.5347 12.6266C30.4724 11.6889 31.7442 11.1621 33.0703 11.1621C34.3964 11.1621 35.6681 11.6889 36.6058 12.6266C37.5435 13.5642 38.0703 14.836 38.0703 16.1621C38.0703 17.4882 37.5435 18.76 36.6058 19.6976C35.6681 20.6353 34.3964 21.1621 33.0703 21.1621ZM33.0703 23.6621C32.0854 23.6621 31.1101 23.4681 30.2002 23.0912C29.2902 22.7143 28.4634 22.1618 27.767 21.4654C27.0705 20.769 26.5181 19.9422 26.1412 19.0322C25.7643 18.1223 25.5703 17.147 25.5703 16.1621C25.5703 15.1772 25.7643 14.2019 26.1412 13.292C26.5181 12.382 27.0705 11.5552 27.767 10.8588C28.4634 10.1624 29.2902 9.60992 30.2002 9.23301C31.1101 8.8561 32.0854 8.66211 33.0703 8.66211C35.0594 8.66211 36.9671 9.45229 38.3736 10.8588C39.7801 12.2653 40.5703 14.173 40.5703 16.1621C40.5703 18.1512 39.7801 20.0589 38.3736 21.4654C36.9671 22.8719 35.0594 23.6621 33.0703 23.6621ZM21.8203 31.7871C20.1627 31.7871 18.573 32.4456 17.4009 33.6177C16.2288 34.7898 15.5703 36.3795 15.5703 38.0371V41.2871C15.5703 41.6186 15.4386 41.9366 15.2042 42.171C14.9697 42.4054 14.6518 42.5371 14.3203 42.5371C13.9888 42.5371 13.6708 42.4054 13.4364 42.171C13.202 41.9366 13.0703 41.6186 13.0703 41.2871V38.0371C13.0703 35.7165 13.9922 33.4909 15.6331 31.8499C17.274 30.209 19.4996 29.2871 21.8203 29.2871C24.1409 29.2871 26.3665 30.209 28.0075 31.8499C29.6484 33.4909 30.5703 35.7165 30.5703 38.0371V41.2871C30.5703 41.6186 30.4386 41.9366 30.2042 42.171C29.9697 42.4054 29.6518 42.5371 29.3203 42.5371C28.9888 42.5371 28.6708 42.4054 28.4364 42.171C28.202 41.9366 28.0703 41.6186 28.0703 41.2871V38.0371C28.0703 37.2163 27.9086 36.4036 27.5945 35.6453C27.2804 34.887 26.8201 34.1981 26.2397 33.6177C25.6593 33.0373 24.9703 32.5769 24.2121 32.2629C23.4538 31.9488 22.641 31.7871 21.8203 31.7871Z"
            fill="#333333"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M21.8203 28.0371C23.1464 28.0371 24.4181 27.5103 25.3558 26.5726C26.2935 25.635 26.8203 24.3632 26.8203 23.0371C26.8203 21.711 26.2935 20.4392 25.3558 19.5016C24.4181 18.5639 23.1464 18.0371 21.8203 18.0371C20.4942 18.0371 19.2224 18.5639 18.2847 19.5016C17.3471 20.4392 16.8203 21.711 16.8203 23.0371C16.8203 24.3632 17.3471 25.635 18.2847 26.5726C19.2224 27.5103 20.4942 28.0371 21.8203 28.0371ZM21.8203 30.5371C23.8094 30.5371 25.7171 29.7469 27.1236 28.3404C28.5301 26.9339 29.3203 25.0262 29.3203 23.0371C29.3203 21.048 28.5301 19.1403 27.1236 17.7338C25.7171 16.3273 23.8094 15.5371 21.8203 15.5371C19.8312 15.5371 17.9235 16.3273 16.517 17.7338C15.1105 19.1403 14.3203 21.048 14.3203 23.0371C14.3203 25.0262 15.1105 26.9339 16.517 28.3404C17.9235 29.7469 19.8312 30.5371 21.8203 30.5371Z"
            fill="#333333"
          />
          <path
            d="M0.945386 3.35691C0.704371 3.11556 0.569101 2.78836 0.569336 2.44728C0.56957 2.1062 0.705289 1.77918 0.946636 1.53816C1.18798 1.29714 1.51518 1.16188 1.85627 1.16211C2.19735 1.16234 2.52437 1.29806 2.76538 1.53941L45.1929 43.9669C45.4339 44.2079 45.5693 44.5348 45.5693 44.8757C45.5693 45.2165 45.4339 45.5434 45.1928 45.7844C44.9518 46.0254 44.625 46.1608 44.2841 46.1608C43.9433 46.1608 43.6164 46.0254 43.3754 45.7844L0.947886 3.35691H0.945386Z"
            fill="#240B3B"
          />
        </g>
      </svg>
    ),
    title: "Hassle-Free Onboarding",
    content:
      "Our hands-on support team ensures a seamless transition. Quickly experience VenueBoost's benefits and leave legacy systems behind.",
  },
  {
    icon: (
      <svg
        width="47"
        height="32"
        viewBox="0 0 47 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_6_7800)">
          <path
            d="M21.3031 30.2656C21.245 30.4927 21.1104 30.6943 20.9209 30.8384C20.7313 30.9825 20.4976 31.0608 20.2571 31.0609C20.1686 31.0608 20.0805 31.0502 19.9946 31.0295L14.2432 29.6311C14.1236 29.6013 14.01 29.5523 13.9071 29.486L9.59348 26.6892C9.47541 26.6128 9.37409 26.5144 9.2951 26.3999C9.21614 26.2854 9.16116 26.1568 9.13329 26.0216C9.077 25.7485 9.13455 25.4649 9.29329 25.2331C9.45204 25.0013 9.69894 24.8403 9.9797 24.7856C10.1187 24.7585 10.2619 24.7582 10.401 24.7849C10.5401 24.8117 10.6725 24.8647 10.7904 24.9412L14.9477 27.6366L20.5194 28.9913C20.657 29.0248 20.7864 29.0844 20.9003 29.1665C21.0142 29.2487 21.1102 29.352 21.183 29.4704C21.2558 29.5887 21.304 29.7199 21.3245 29.8563C21.3451 29.9928 21.3378 30.1319 21.3031 30.2656ZM45.1592 13.38C45.056 13.6848 44.8916 13.9668 44.6757 14.2096C44.4598 14.4522 44.1964 14.6509 43.901 14.7941L39.5874 16.8917L29.6464 26.5599C29.444 26.756 29.17 26.8659 28.8843 26.8658C28.7958 26.8656 28.7077 26.8551 28.6219 26.8343L17.1189 24.0375C16.9896 24.0048 16.8678 23.9491 16.7595 23.8732L6.75905 16.9301L2.36815 14.7941C1.77142 14.5038 1.31766 13.9949 1.10667 13.3792C0.895675 12.7637 0.944718 12.0917 1.24302 11.5113L5.7094 2.8255C6.00788 2.24516 6.53115 1.80386 7.16412 1.59865C7.79711 1.39345 8.48797 1.44115 9.0848 1.73126L13.1755 3.72048L22.8362 1.03555C23.03 0.981638 23.2355 0.981638 23.4293 1.03555L33.0901 3.72048L37.1808 1.73126C37.7776 1.44115 38.4685 1.39345 39.1014 1.59865C39.7345 1.80386 40.2577 2.24516 40.5562 2.8255L45.0226 11.5113C45.171 11.7985 45.2596 12.1116 45.283 12.4323C45.3065 12.753 45.2643 13.0751 45.1592 13.38ZM3.33332 12.9185L6.83453 14.6297L11.6299 5.30941L8.11963 3.60686C8.03429 3.56565 7.93562 3.55906 7.8453 3.58856C7.75498 3.61806 7.6804 3.68122 7.63794 3.76418L3.17156 12.45C3.12976 12.5328 3.1233 12.6283 3.15359 12.7156C3.16763 12.7596 3.19084 12.8004 3.22176 12.8353C3.25269 12.8702 3.29066 12.8985 3.33332 12.9185ZM34.456 18.9106L28.9328 14.6088C25.5179 17.472 21.1 17.895 17.4658 15.6366C17.1478 15.4399 16.8794 15.1764 16.6801 14.8653C16.4809 14.5542 16.3561 14.2036 16.3149 13.8394C16.2737 13.4751 16.3171 13.1065 16.4419 12.7607C16.5668 12.415 16.7699 12.1009 17.0363 11.8417L25.2536 4.08756C25.3731 3.97545 25.5177 3.8917 25.676 3.84284L23.1328 3.1349L13.8208 5.71495L8.69298 15.696L17.8415 22.05L28.5536 24.6545L34.456 18.9106ZM37.6337 15.8202L32.531 5.88975H26.4453L18.5532 13.3363C18.5181 13.372 18.4918 13.4148 18.4759 13.4616C18.4601 13.5085 18.4552 13.5582 18.4615 13.6072C18.467 13.6605 18.4853 13.712 18.5145 13.7574C18.5438 13.8029 18.5835 13.8412 18.6305 13.8693C21.0191 15.3534 24.7665 15.7695 28.1186 12.4849C28.3062 12.3018 28.5567 12.1925 28.8221 12.178C29.0874 12.1635 29.3489 12.2448 29.5564 12.4063L35.9945 17.4265L37.6337 15.8202ZM43.0905 12.45L38.6276 3.76418C38.5852 3.68122 38.5106 3.61806 38.4203 3.58856C38.33 3.55906 38.2312 3.56565 38.1459 3.60686L34.6447 5.30941L39.4311 14.6297L42.9323 12.9272C42.9749 12.9072 43.0129 12.8789 43.0438 12.844C43.0747 12.8091 43.0979 12.7684 43.112 12.7244C43.1282 12.6799 43.135 12.6326 43.1319 12.5854C43.1288 12.5382 43.116 12.4922 43.0941 12.45H43.0905Z"
            fill="#240B3B"
          />
        </g>
      </svg>
    ),
    title: "Built for Omni-Channel Success",
    content:
      "Purpose-built to enable frictionless online and in-person transactions, sales, and reservations across all channels.",
  },
];

const CustomCarouselAbout = () => {
  const navigate = useNavigate();
  return (
    <div className={"w-full py-12"}>
      <h1 className="text-[#240B3B] text-26 md:text-[42px] leading-[28px] md:leading-[50px] font-extrabold text-center">
        Transform your venue with VenueBoost
      </h1>

      <Carousel
        responsive={responsive}
        infinite={true}
        autoPlay={true}
        showDots={false}
        partialVisible={false}
        containerClass={"pt-12 pb-3 custom-carousel-about"}
        arrows={true}
      >
        {data.map((item, index) => (
          <div
            onClick={() => {}}
            className="item-shadow h-[300px] w-full md:h-[332px] cursor-pointer md:w-[396px] flex flex-col rounded-[15px] px-[2px] out-div"
            key={index}
          >
            <div className="w-full h-full !bg-white rounded-[15px] flex flex-col gap-4 justify-center items-center px-1 md:px-6">
              <div>{item.icon}</div>
              <div className="text-[#240B3B] text-[28px] font-semibold leading-[35px] text-center">
                {item.title}
              </div>
              <div className="text-[#292D34] text-18 font-normal text-center">
                {item.content}
              </div>
            </div>
          </div>
        ))}
      </Carousel>
    </div>
  );
};
export default CustomCarouselAbout;
